export const MIN_CELL_WIDTH = 200;
export const MIN_CELL_HEIGHT = 50;
